require('./dropdownSearch.tpl.html');
require('./dropdownSearchController');

const DropdownSearchComponent = {
    templateUrl: '/ui/dropdown/common/search/dropdownSearch.tpl.html',
    controller: 'umDropdownSearchController',
    bindings: {
        searchTerm: '<',
        onChange: '&'
    }
};

angular.module('umCore')
    .component('umDropdownSearch', DropdownSearchComponent);
